import React from 'react';
import TitleHeader from 'components/presenters/header/TitleHeader';
import MatchingTutorial from 'components/presenters/tutorial/MatchingTutorial';
import {Layout} from './style';
import {getQueryStringObject} from 'utils/utils';
export default function TutorialLayout() {
    const queryString = getQueryStringObject(); 
    const type = queryString['type'];
    return (
        <Layout>
            <TitleHeader />
            <MatchingTutorial type={type}/>
        </Layout>
    )
}
